module.exports = __webpack_public_path__ + "public/media/digital-header.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/digital-header.png
// module id = ./images/services/digital-header.png
// module chunks = 0